import { Box, Stack } from "@mui/material";
import type { PropsWithChildren } from "react";
import {
  getSupportedListAggregationTypes,
  supportedListAggregations,
} from "../../../utilities/aggregationHelper.ts";
import PartContainer from "../../viewer/common/PartContainer.tsx";
import type { EditorProps } from "../../viewer/common/Types.ts";
import { SupportedAggregationsContextProvider } from "../../viewer/common/context/SupportedAggregationsContextProvider.tsx";
import BuildProgressWrapper from "../BuildProgressWrapper.tsx";
import BuilderMoreAction from "../common/fields/BuilderMoreAction.tsx";
import ListPreviewGrid from "./preview/ListPreviewGrid.tsx";
import ListTableComponent from "./table/ListTableComponent.tsx";

const ListContainer = ({ children }: PropsWithChildren) => {
  return (
    <SupportedAggregationsContextProvider
      aggregations={supportedListAggregations}
      getSupportedAggregationTypes={getSupportedListAggregationTypes}
    >
      {children}
    </SupportedAggregationsContextProvider>
  );
};

const ListEditor = ({ ReportTypeSelector }: EditorProps) => {
  return (
    <ListContainer>
      <Stack direction="row" sx={{ flex: 1 }}>
        <PartContainer
          sx={{ maxWidth: "24rem", minWidth: "24rem" }}
          caption={<Box sx={{ pl: "1.3rem" }}>Builder</Box>}
          actions={<BuilderMoreAction />}
        >
          <ListTableComponent ReportTypeSelector={ReportTypeSelector} />
        </PartContainer>
        <BuildProgressWrapper>
          <ListPreviewGrid />
        </BuildProgressWrapper>
      </Stack>
    </ListContainer>
  );
};

export default ListEditor;
